/* Aldersteel — product page add-to-cart -> open cart drawer.
   Self-contained. Intercepts the custom PDP form (id starts "as-pf-") in the
   capture phase so it overrides any theme component handler. Opens the drawer
   immediately for perceived speed, adds via AJAX requesting the rendered cart
   sections in the SAME request (one round trip), then morphs the drawer
   contents and updates the header bubble — no extra fetches. */
(function () {
  function getDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return;
    if (typeof d.open === 'function') d.open();
    else if (typeof d.showDialog === 'function') d.showDialog();
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function countFromSections(sections) {
    for (var key in sections) {
      if (!Object.prototype.hasOwnProperty.call(sections, key)) continue;
      try {
        var doc = new DOMParser().parseFromString(sections[key], 'text/html');
        var el = doc.querySelector('[ref="cartItemCount"]');
        if (el) {
          var n = parseInt((el.textContent || '').trim(), 10);
          if (!isNaN(n)) return n;
        }
      } catch (e) {}
    }
    return null;
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      // NB: read the id via getAttribute — a form with <input name="id"> shadows form.id.
      var formId = form && form.getAttribute ? form.getAttribute('id') : null;
      if (!formId || formId.indexOf('as-pf-') !== 0) return;

      // Take full control of this submit (block Horizon's product-form-component).
      e.preventDefault();
      e.stopImmediatePropagation();

      var idInput = form.querySelector('[name="id"]');
      var variantId = idInput ? idInput.value : null;
      if (!variantId) return;

      var btn = form.querySelector('button[name="add"], button[type="submit"]');
      // Only swap label text on plain-text buttons; icon buttons (with child elements) keep their markup.
      var canSwap = btn && btn.children.length === 0;
      var label = btn ? btn.textContent : '';
      if (btn && btn.disabled) return;
      if (btn) { btn.disabled = true; if (canSwap) btn.textContent = 'Adding…'; }

      // Open instantly — the contents fill in as soon as the add resolves.
      openDrawer();

      var ids = cartSectionIds();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: ids.join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          return r.json().then(function (d) { return { ok: r.ok, d: d }; });
        })
        .then(function (res) {
          if (!res.ok) throw new Error((res.d && res.d.description) || 'Add to cart failed');
          var sections = (res.d && res.d.sections) || {};
          var count = countFromSections(sections);

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: { item_count: count },
                sourceId: 'as-atc',
                data: { source: 'as-atc', itemCount: count == null ? 0 : count, sections: sections }
              }
            })
          );

          openDrawer();
        })
        .catch(function (err) {
          console.error('[aldersteel-atc]', err);
          window.location.href = '/cart';
        })
        .finally(function () {
          if (btn) { btn.disabled = false; if (canSwap) btn.textContent = label || 'Add to cart'; }
        });
    },
    true
  );
})();
